export default "__VITE_ASSET__83f58d4a__"